<template>
  <el-container class="whitelist-box" direction="vertical">
    <div class="page-title">【{{ cardName }}】白名单管理</div>
    <div class="search-x">
      <div class="search-item">
        <span class="label">白名单手机号</span>
        <el-input v-model.trim="form.mobile" clearable class="input-box" />
      </div>
      <div class="search-item">
        <span class="label">白名单姓名</span>
        <el-input v-model.trim="form.name" clearable class="input-box" />
      </div>
      <div class="search-item">
        <span class="label">家属手机号</span>
        <el-input v-model.trim="form.familyMobile" clearable class="input-box" />
      </div>
      <div class="search-item">
        <span class="label">家属姓名</span>
        <el-input v-model.trim="form.familyName" clearable class="input-box" />
      </div>
      <div class="search-item">
        <span class="label">状态</span>
        <el-select v-model="form.status" clearable placeholder="请选择">
          <el-option label="启用" value="ON" />
          <el-option label="停用" value="OFF" />
        </el-select>
      </div>
      <el-button type="primary" @click="getData(true)">查询</el-button>
      <el-button type="primary" @click="reset">重置</el-button>
      <el-button type="primary" :disabled="!selection.length" @click="batchStatus('ON')">批量启用</el-button>
      <el-button type="primary" :disabled="!selection.length" @click="batchStatus('OFF')">批量停用</el-button>
      <el-button type="warning" @click="toAdd">新增</el-button>
      <el-button type="primary" @click="downloadTemplate">下载excel模板</el-button>
      <el-upload
        class="upload-inline"
        action=""
        :show-file-list="false"
        :http-request="onImport"
        accept=".xls,.xlsx"
      >
        <el-button type="primary">导入</el-button>
      </el-upload>
    </div>
    <el-table :data="tableData" v-loading="loading" border @selection-change="(val) => (selection = val)">
      <el-table-column type="selection" width="50" />
      <el-table-column prop="mobile" label="手机号" min-width="130" />
      <el-table-column prop="name" label="姓名" min-width="100">
        <template slot-scope="{ row }">{{ row.name || "-" }}</template>
      </el-table-column>
      <el-table-column label="开通时间" width="170">
        <template slot-scope="{ row }">{{ formatTime(row.beginTime) }}</template>
      </el-table-column>
      <el-table-column label="到期时间" width="170">
        <template slot-scope="{ row }">{{ formatTime(row.endTime) }}</template>
      </el-table-column>
      <el-table-column label="家属个数" width="100">
        <template slot-scope="{ row }">
          <el-button v-if="row.familyCount > 0" type="text" @click="showFamily(row)">{{ row.familyCount }}</el-button>
          <span v-else>0</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="{ row }">
          <el-button type="text" @click="toggleOne(row)">
            {{ isOn(row) ? "停用" : "启用" }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="80">
        <template slot-scope="{ row }">{{ isOn(row) ? "启用" : "停用" }}</template>
      </el-table-column>
    </el-table>
    <div class="page-x">
      <el-pagination
        @size-change="getData(true)"
        @current-change="getData()"
        :current-page.sync="page.pageNo"
        :page-size.sync="page.pageSize"
        :page-sizes="[10, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total"
        background
      />
    </div>
    <p class="tip">excel模板也是这个表前4列。到期时间选填，不填就按默认时长算；开通时间选填，不填就按导入表单时间</p>

    <el-dialog title="权益人家属" :visible.sync="familyVisible" width="640px">
      <div v-if="currentRow" class="family-head">
        {{ currentRow.mobile }} {{ currentRow.name || "" }}　已有家属个数：{{ familyList.length }}
      </div>
      <el-table :data="familyList" border size="small">
        <el-table-column prop="name" label="姓名" min-width="100" />
        <el-table-column label="手机尾号" width="100">
          <template slot-scope="{ row }">{{ row.mobileTail || tailOf(row.mobile) || "-" }}</template>
        </el-table-column>
        <el-table-column label="脱敏手机号" min-width="120">
          <template slot-scope="{ row }">{{ row.mobile || "-" }}</template>
        </el-table-column>
        <el-table-column label="userId" width="110">
          <template slot-scope="{ row }">{{ row.userId || "-" }}</template>
        </el-table-column>
        <el-table-column label="是否关联用户" width="110">
          <template slot-scope="{ row }">
            {{ row.linked || row.userId ? "已关联" : "未关联" }}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </el-container>
</template>

<script>
import { dateFormat } from "@/assets/js/until.js";

export default {
  name: "rightsCardWhitelist",
  data() {
    return {
      form: {},
      loading: false,
      page: { pageSize: 10, pageNo: 1, total: 0 },
      tableData: [],
      selection: [],
      familyVisible: false,
      familyList: [],
      currentRow: null,
    };
  },
  computed: {
    cardId() {
      return this.$route.query.cardId;
    },
    cardName() {
      return this.$route.query.cardName || "权益卡";
    },
  },
  created() {
    if (!this.cardId) {
      this.$message.error("缺少 cardId");
      this.$router.back();
      return;
    }
    this.getData(true);
  },
  methods: {
    isOn(row) {
      return row.status === 0 || row.status === "ON" || (row.status && row.status.code === 0);
    },
    formatTime(t) {
      return t ? dateFormat(t, "Y/m/d H:i:s") : "-";
    },
    reset() {
      this.form = {};
      this.getData(true);
    },
    toAdd() {
      this.$router.push({
        name: "rightsCardWhitelistAdd",
        query: { cardId: this.cardId, cardName: this.cardName },
      });
    },
    async getData(reset) {
      if (reset) this.page.pageNo = 1;
      this.loading = true;
      try {
        const res = await this.axios.get(this.getApiUrl("rightsCardWhitelistPage"), {
          params: {
            cardId: this.cardId,
            ...this.form,
            pageNo: this.page.pageNo,
            pageSize: this.page.pageSize,
          },
        });
        const data = res.data || {};
        this.tableData = data.data || [];
        this.page.total = data.total || 0;
      } finally {
        this.loading = false;
      }
    },
    batchStatus(status) {
      const ids = this.selection.map((x) => x.id);
      this.$confirm(`确定批量${status === "ON" ? "启用" : "停用"}？`, "提示", { type: "warning" })
        .then(async () => {
          const res = await this.axios.post(
            this.getApiUrl("rightsCardWhitelistBatchStatus"),
            {
              ids,
              status: status === "ON" ? 0 : 1,
            },
            { toJSON: true }
          );
          if (res && res.code === 1) {
            this.$message.success("操作成功");
            this.getData();
          } else {
            this.$message.error((res && res.msg) || "操作失败");
          }
        })
        .catch(() => {});
    },
    toggleOne(row) {
      const next = this.isOn(row) ? "OFF" : "ON";
      this.axios
        .post(this.getApiUrl("rightsCardWhitelistStatus"), { id: row.id, status: next }, { toJSON: true })
        .then((res) => {
          if (res && res.code === 1) {
            this.$message.success("操作成功");
            this.getData();
          } else {
            this.$message.error((res && res.msg) || "操作失败");
          }
        });
    },
    async showFamily(row) {
      this.currentRow = row;
      const res = await this.axios.get(this.getApiUrl("rightsCardWhitelistFamily"), {
        params: { whitelistId: row.id },
      });
      this.familyList = res.data || [];
      this.familyVisible = true;
    },
    tailOf(mobile) {
      if (!mobile) return "";
      const digits = String(mobile).replace(/\D/g, "");
      return digits.length >= 4 ? digits.slice(-4) : "";
    },
    downloadTemplate() {
      window.open(this.getApiUrl("rightsCardWhitelistTemplate"), "_blank");
    },
    async onImport({ file }) {
      const fd = new FormData();
      fd.append("file", file);
      await this.axios.post(
        this.getApiUrl("rightsCardWhitelistImport") + "?cardId=" + this.cardId,
        fd,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      this.$message.success("导入完成");
      this.getData(true);
    },
  },
};
</script>

<style scoped>
.whitelist-box {
  padding: 16px;
}
.page-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
}
.search-x {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 12px;
}
.search-item {
  display: flex;
  align-items: center;
  margin: 0 12px 8px 0;
}
.search-item .label {
  margin-right: 8px;
  white-space: nowrap;
}
.input-box {
  width: 160px;
}
.upload-inline {
  display: inline-block;
  margin: 0 0 8px 8px;
}
.page-x {
  margin-top: 12px;
  text-align: right;
}
.tip {
  color: #909399;
  font-size: 12px;
  margin-top: 8px;
}
.family-head {
  margin-bottom: 12px;
}
</style>
